import { Component, OnInit, Directive, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

import { SessionService } from '../../../services/session.service';

import { Caja } from '../../../models/caja';
import { CajaService } from '../../../services/caja.service';

import { Validation } from '../../../config/validation';
import { SweetMessage } from '../../../config/sweet-message';

import { Empresa } from "../../../models/empresa";
import { EmpresaService } from "../../../services/empresa.service";
import { Sucursal } from "../../../models/sucursal";
import { SucursalService } from "../../../services/sucursal.service";
import { Usuario } from "../../../models/usuario";
import { UsuarioService } from "../../../services/usuario.service";
import { Transportista } from '../../../models/transportista';
import { GuiaremisionService } from '../../../services/guiaremision.service';
import { TransportistaService } from '../../../services/transportista.service';
@Component({
  selector: 'app-transportista-add',
  templateUrl: './transportista-add.component.html',
  styleUrls: ['./transportista-add.component.css'],
  providers: [CajaService,EmpresaService,SucursalService,UsuarioService,SessionService,TransportistaService],
})
export class TransportistaAddComponent implements OnInit {
	@Input() btnCalelHidden: boolean = false;
	myForm: FormGroup;
	public vl: Validation;
	public transportista:Transportista;
	public loading = false;
	public msg: SweetMessage;
	constructor(
		public fb: FormBuilder,
		private ss: SessionService,
		private transportistaService: TransportistaService,
	) {
		this.msg = new SweetMessage();
		this.vl = new Validation();
		this.transportista = new Transportista();
		this.transportista.tipo_identificacion_id = 1;
	}

	ngOnInit() {

	}

	onSubmit() {
		//setea valores del formulario a la entidad
		this.setValueEntity();
		this.loading = true;
		this.transportistaService.save(this.transportista).subscribe(
			res => {
				this.loading = false;
				this.msg.showMessage('success-message', res.message);
				this.transportista = new Transportista();
				this.transportista.tipo_identificacion_id = 1;
			},
			err => {
				this.loading = false;
				this.msg.showMessage('error-message',err);
			}
		);
	}

	setValueEntity(){
		this.transportista.empresa_id = this.ss.getData("empresa_id");
		this.transportista.usuario_id = this.ss.getData("usuario_id");
	}

	// onForm() {
	// 	this.myForm = this.fb.group({
	// 		caja_id: ['', [Validators.required]],
	// 		tipo_comprobante_id: ['', [Validators.required]],
	// 	});
	// }

	// validErrorForm(campo) {
	// 	return this.vl.validErrorForm(campo, this.myForm);
	// }

	// validTypeMsgForm(nombre, campo) {
	// 	return this.vl.validTypeMsgForm(nombre, campo, this.myForm);
	// }

	onChangeIdentificacion(id){
		this.transportista.tipo_identificacion_id = id;
	}

	isValidForm(){
		
		
		if(this.transportista.dni){
			if(this.transportista.tipo_identificacion_id == 1 && this.transportista.dni.length != 13){
				return false;
			}
			if(this.transportista.tipo_identificacion_id == 2 && this.transportista.dni.length != 10){
				return false;
			}
			if(this.transportista.tipo_identificacion_id == 3 && this.transportista.dni.length < 4){
				return false;
			}
		}else{
			return false;
		}
		if( this.transportista.nombre.toString().trim().length < 1 ){
			return false;
		}
		if( this.transportista.placa.toString().trim().length < 1 ){
			return false;
		}

		

		return true;
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/transportista-add/transportista-add.component.ts